import { MissionEventHandler } from "../mission"
import { tag } from "../utils"
import * as skylineApi from '../skylineApi'

export default class RoamEvents extends MissionEventHandler {
  constructor(mission, rootElement) {
    super(mission)

    this.root = rootElement

    // this.root.addEventListener("mousemove", this.handleMouseOver.bind(this))
    // this.root.addEventListener("click", this.handleMouseClick.bind(this))

    // Main replay bars
    this.timelineBox = document.getElementById("timelineBox")
    this.selectionBox = this.timelineBox.querySelector(".timelineSelection")

    this.roams = []
  }

  drawRoams() {
    for (const roam of this.roams) {
      if (roam.element) {
        let left = `${roam.index / this.mission.history.length * 100}%`
        roam.element.style.left = left
      }
    }
  }

  createElement(roam) {
    const device = skylineApi.getDevice(roam.message.currentId)
    let targetName = device ? device.name : roam.message.currentRadioId

    const element = tag('div', { class: 'roamDot' }, null,
      tag('div', { class: 'roamTooltip' }, `Roam to ${targetName}`)
    )
    element.addEventListener('click', this.handleMouseClick(roam))
    this.timelineBox.appendChild(element)
    return element
  }

  processMessage(message, index) {
    if (message.type === 'MISSION_ROAM') {
      const roam = {
        index,
        message: message,
      }
      if (this.roams.length > 0) {
        roam.element = this.createElement(roam)
      }
      this.roams.push(roam)
    }
  }

  handleMissionHistoryAppend(message) {
    this.processMessage(message, this.mission.history.length - 1)
    this.drawRoams()
  }

  handleMissionHistoryLoad() {
    this.removeElements()
    this.roams = []

    for (let i = 0; i < this.mission.history.length; i++) {
      this.processMessage(this.mission.history[i], i)
    }

    this.drawRoams()
  }

  handleMouseOver(event) {

    const bounds = this.timelineBox.getBoundingClientRect()
    const posX = event.clientX - bounds.left
    const percent = posX / bounds.width
    if (percent >= 1 || percent < 0) return

    this.selectionBox.style.width = `${percent * 100}%`


    const index = Math.floor(this.mission.history.length * percent)
    if (!this.mission.history[index]) return

    this.tooltip.innerHTML = "<div>" + new Date(this.mission.history[index].timestamp).toLocaleTimeString() + "</div>"
    this.tooltip.style.top = `${bounds.top - 70}px`
    this.tooltip.style.left = `${event.clientX - this.tooltip.getBoundingClientRect().width / 2}px`
  }

  handleMouseClick(roam) {
    return () => {
      this.mission.setReplayIndex(roam.index)
    }
  }

  removeElements() {
    for (const roam of this.roams) {
      if (roam.element) {
        this.timelineBox.removeChild(roam.element)
      }
    }
  }

  cleanup() {
    super.cleanup()
    this.removeElements()
  }
}